<template>
  <div
    class="d-flex align-center justify-center"
  >
    <div>
      <div class="pa-10 ma-10">
        <v-img src="../assets/PreventiaLogoSmall.png" maxHeight="130" contain />
      </div>
      <v-alert
        prominent
        outlined
        type="error"
      >
        <v-row align="center">
          <v-col class="title">
            Your account has been deactivated.
          </v-col>
          <v-col class="shrink">
            <v-btn text @click="logout">
              Logout
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeactiveAccount',
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push({
            path: '/login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        });
    }
  }
};
</script>
